import React, {Component} from 'react';

class Completed extends Component {
    formatBytes(bytes) {
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
        if (bytes === 0) return 'n/a'
        const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
        if (i === 0) return `${bytes} ${sizes[i]}`
        return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`
    }

    render() {
        const { formData } = this.props;
        const { file } = formData;
        var uploadSize = 0
        
        if( formData === null || formData === undefined ) return 
        for(var i =0; i< file.length; i++){
            uploadSize += file[i].size
        }
        return ( 
                    <div className="container">
                        <div className="box">
                            <div className="UploadCompletedTitle has-text-centered">
                                <span className="icon is-very-large">
                                    <i className="fas fa-check-circle fa-5x"></i>
                                </span>
                                <h2 className="title is-spaced is-size-2 is-size-4-mobile has-text-white">อัพโหลดสำเร็จ</h2>
                            </div>
                            <hr />
                            <div className="UploadCompletedSummary content">
                                <h4 className="title is-size-5">สรุปข้อมูลส่วนตัว</h4>
                                <div className="columns is-mobile">
                                    <div className="column is-narrow">
                                        <p className="has-text-grey-light">ชื่อ-นามสกุล</p>
                                    </div>
                                    <div className="column">
                                        <p>{formData.name}</p>
                                    </div>
                                </div>
                                <div className="columns is-mobile">
                                    <div className="column is-narrow">
                                        <p className="has-text-grey-light">เบอร์โทรศัพท์</p>
                                    </div>
                                    <div className="column">
                                        <p>{formData.phone}</p>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="UploadCompletedSummary content">
                                <h4 className="title is-size-5">สรุปข้อมูลไฟล์ภาพโดรน</h4>
                                <div className="columns is-mobile">
                                </div>
                                <div className="columns is-mobile">
                                    <div className="column is-narrow">
                                        <p className="has-text-grey-light">ขนาดไฟล์ทั้งหมด</p>
                                    </div>
                                    <div className="column">
                                        <p>{ (file !== null) ? this.formatBytes(uploadSize) : null }</p>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="UploadCompletedEnding content has-text-centered">
                                <p>ทางทีมงานจะตรวจสอบข้อมูลและจะติดต่อกลับไป</p>
                                <button className="UploadCompletedAction button is-primary" onClick={this.props.setDefault}>ย้อนกลับ</button>
                            </div>
                        </div>
                    </div>

        )
    }
}

export default Completed;


// WEBPACK FOOTER //
// ./src/PageManagement/_Completed.js